import styled from '@emotion/styled'
import { MdErrorOutline } from 'react-icons/md'
import { Card } from 'react-bootstrap'

export const styledLink = styled('a')`
  label: styledLink;
  text-decoration: underline;
  font-weight: bold;
  color: ${(props) => props.theme.colors.alertRed};
  :hover {
    color: ${(props) => props.theme.colors.alertRed};
    cursor: pointer;
  }
`

export const styledAlertIcon = styled(MdErrorOutline)`
  label: styledAlertIcon;
  color: ${(props) => props.theme.colors.alertRed};
  height: 1.4em;
  width: 1.4em;
  position: absolute;
  left: 8px;
  top: 13px;
`

export const EOLButtonContainer = styled('div')`
  label: EOLButtonContainer;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: center;
  }
`

export const ProceedButtonDiv = styled.div`
  label: ProceedButtonDiv;
  margin-top: 18px;
  margin-right: 12px;
  @media (max-width: 719px) {
    margin-top: 0px;
    margin-right: 0px;
    width: 100%;
  }
`

export const ResidualBox = styled(Card)`
  label: ResidualBox;
  border-width: ${(props) => (props.theme.brand === 'Maxxia' ? '1px' : '2px')};
  border-style: solid;
  border-color: ${(props) => props.theme.colors.primary};
  padding: 5px 20px 7px 16px;
  font-weight: normal;
  box-sizing: border-box;
  @media (min-width: 720px) {
    max-width: 184px;
  }
  .card-text {
    > .row:first-child {
      margin-bottom: 13px;
    }
  }
`

export const EOLOptionTitles = styled.div`
  label: EOLOptionTitles;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '14px')};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 900)};
`

export const CongratulationsDiv = styled.div`
  label: CongratulationsDiv;
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 900)};
  margin-bottom: 3px;
`
